export type LogoRef = { src: string };

const bankLogos: Record<string, LogoRef> = {
  "CSAS": { src: "/img/banks/csas-logo.png" },
  "CSOB": { src: "/img/banks/csob-logo.png" },
  "KB": { src: "/img/banks/kb-logo.png" },
};

export function getBankLogo(code: string): LogoRef | null {
  return bankLogos[code] ?? null;
}

export const placeholderLogo: LogoRef = { src: "/img/banks/placeholder.svg" };
